import { useState, type ReactNode } from 'react';
import { num } from '../utils';

interface RankListProps {
  entries: Array<[string, number]>;
  selected: string[];
  onToggle: (value: string) => void;
  labelFor: (value: string) => string;
  color: string;
  limit?: number;
  // Optional short note after the label (e.g. "3 không có hàng") — one fact per row, no extra column.
  note?: (value: string) => ReactNode;
}

// Ranked list with an inline bar: reads like a table, filters like a chart.
export function RankList({ entries, selected, onToggle, labelFor, color, limit = 10, note }: RankListProps) {
  const [open, setOpen] = useState(false);
  const shown = open ? entries : entries.slice(0, limit);
  const max = entries[0]?.[1] || 1;
  const total = entries.reduce((s, e) => s + e[1], 0) || 1;
  const sel = new Set(selected);
  if (!entries.length) return <div className="muted ins-empty">Không có dữ liệu theo bộ lọc hiện tại.</div>;
  return (
    <div className="ins-rank">
      {shown.map(([key, n]) => {
        const extra = note?.(key);
        return (
          <button key={key} type="button" className={`ins-rank-row ${sel.has(key) ? 'is-selected' : ''} ${sel.size && !sel.has(key) ? 'is-dim' : ''}`}
            aria-pressed={sel.has(key)} onClick={() => onToggle(key)} title="Bấm để lọc">
            <span className="ins-rank-label">{labelFor(key)}{extra ? <span className="muted"> · {extra}</span> : null}</span>
            <span className="ins-rank-bar"><i style={{ width: `${Math.max(2, (n / max) * 100)}%`, background: color }} /></span>
            <b className="tnum">{num(n)}</b>
            <small className="tnum">{Math.round((n / total) * 100)}%</small>
          </button>
        );
      })}
      {entries.length > limit && (
        <button type="button" className="ins-more" onClick={() => setOpen(v => !v)}>{open ? 'Thu gọn' : `Xem thêm ${entries.length - limit}`}</button>
      )}
    </div>
  );
}
